import { Entity } from '@adornis/baseql/decorators.js';
import { AdornisFilter } from '@adornis/filter/AdornisFilter.js';

@Entity()
export class ChancenDynamicClassProductFilter extends AdornisFilter {
  static override _class = 'ChancenDynamicClassProductFilter';

  override searchFields: string[] | undefined = ['class', 'name', 'kuerzel'];
}
